import { combineReducers } from 'redux'
import optionsReducer from './options/reducer'
import dataReducer from './data/reducer'
import notificationsReducer from './notifications/reducer'
import contestsReducer from './contests/reducer'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// keep the chosen race between visits, not the race list; the list always comes from the server
const contestsPersistConfig = {
  key: 'WimedoAppRace',
  storage,
  whitelist: [ 'selected', 'newest' ]
}

const rootReducer = combineReducers({
  options: optionsReducer,
  data: dataReducer,
  notifications: notificationsReducer,
  contests: persistReducer( contestsPersistConfig, contestsReducer )
});

export default rootReducer;